import { LegendItem } from "helpers/models";

const LayerTitle = {
  CS_Tornado_Global_SwissRe: " per approx. 25km x 25km",
  CS_Lightning_Global_SwissRe: " per approx. 50 km × 50 km"
};

export default (legendItems: LegendItem[]): { [key: string]: string } => {
  const layerSubtitle: { [key: string]: string } = {};

  if (!legendItems) {
    return layerSubtitle;
  }

  legendItems.forEach((item) => {
    if (!item) {
      return;
    }

    const layerId = item.layerId as keyof typeof LayerTitle;
    const subtitle = item.subtitle;

    if (!layerId) {
      return;
    }

    if (!subtitle) {
      return;
    }

    const layer = LayerTitle[layerId];

    if (!layer) {
      layerSubtitle[layerId] = subtitle;
      return;
    }

    layerSubtitle[layerId] = subtitle.replace(LayerTitle[layerId], "");
  });

  return layerSubtitle;
};
